import { render, staticRenderFns } from "./ReceivingCloseTable.vue?vue&type=template&id=48f8db5d"
import script from "./ReceivingCloseTable.vue?vue&type=script&lang=js"
export * from "./ReceivingCloseTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports